






















































































import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import hexabaseState from '@/store/hexabase';
import Setting from '@/models/settingModel';
import { FieldChildrenProp } from '@/services/hexabase/types';
import { employeeMasterForm, EmployeeRules, addGroupDialogForm } from '@/constants/form/settingEmployeeForm';
import { EmployeeDetailDefine } from '@/constants/setting/employee';
import { MemberList } from '@/constants/setting/types';

import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import EditAction from '@/components/setting/detail/EditAction.vue';
import InputSettingEmployeePanel from '@/components/setting/detail/InputSettingEmployeePanel.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';

import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import Button from '@/components/common/elements/Button.vue';
import userState from '@/store/user';
import appState from '@/store/app';

Component.registerHooks(['beforeRouteEnter']);
@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    EditAction,
    InputSettingEmployeePanel,
    ExecAction,
    TransitionDialog,
    AutoCreateForm,
    SingleText,
    Button
  },
  beforeRouteEnter(to: Route, from: Route, next: any): void {
    next((vm: any) => {
      vm.prevRoute = from;
      next();
    });
  }
})
export default class SettingEmployeeRegister extends Vue {
  // model
  private setting = new Setting();
  // アプリケーションID
  private applicationId = hexabaseState.applicationId;
  // 社員マスタのデータストアのID
  private employeeMasterDsId = hexabaseState.datastoreIds['社員マスタ'];
  // マスタデータ
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  // 社員基本情報のデータ
  private fieldsData: FieldChildrenProp[] = [];
  // 社員基本情報のカラムデータ
  private fieldCols = '';
  // 登録用データ
  private registDataPayload: any = {
    'item': {},
    'return_item_result': true,
    'return_display_id': true
  };
  private registerBaseGroupItem: any = {};
  private registerEmployeeGroupItem: any = {};
  // ダイヤログ用データ
  private dialogStatus = false;
  private bodyText = '';
  private button = [
    {
      id: 1,
      color: 'primary',
      type: 'routing',
      name: 'routing',
      value: '詳細画面へ',
      route: `/setting/employee/edit/:id`      
    }
  ];

  // コンポーネントで使用するタイトル等
  private execActionMessage = EmployeeDetailDefine.regist.message.execAction;
  private dialogTitle = EmployeeDetailDefine.regist.dialogTitle;
  // キャンセルボタン押下時の遷移時に使用
  private prevRoute: any = null;

  // 企業・グループ追加
  // 企業・グループ追加用ダイヤログ開閉フラグ
  private addGroupDialog = false;
  // ダイアログのエリア外を押下した際にBOXを閉じるか
  private isPersistent?: boolean = true;
  private addGroupDialogInformation = {
    title: '企業・グループ追加',
    checkMessage: ''
  };
  private dialogData = { cols: {}, datas: {} as { [k: string]: any } };

  private adddGroupRegistData: any = {
    'item': {},
    'return_item_result': true,
    "return_display_id": true
  };

  private checkAddGroupFlag = false;
  private groupTreeData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  private extractionGroupData: Array<{}> = [];


  async mounted() {
    this.initial();
  }

  public async initial() {
    try {
      this.$store.commit('hexabase/setIsLoading', true);

      // 管理者権限判定
      if (!userState.isAdmin) {
        this.setError(this.setting.getDefaultRoleErrorMessage());
        return;
      }

      await this.setting.loadMasterData();
      this.masterData = this.setting.getMaster();

      const [newAction, groupData] = await Promise.all([
        this.setting.getNewActionList(this.employeeMasterDsId),
        this.setting.getGroup()
      ]);

      const initialAction = newAction.actions.filter(
        action => action.display_id === EmployeeDetailDefine.regist.registActionName
      );
      const inputFields = await this.setting.getFieldsByActionId(
        this.employeeMasterDsId,
        initialAction[0].action_id
      );

      let fields = await this.setting.getField(
        this.applicationId,
        this.employeeMasterDsId,
        this.masterData,
        employeeMasterForm,
        undefined,
        inputFields
      );

      const groupTreeData = await this.setting.getGroupTree();
      this.groupTreeData = groupTreeData.result;
      this.extractionGroupDataCreate(groupTreeData.result[0], this.extractionGroupData);

      const addButtonItem = JSON.parse(JSON.stringify(employeeMasterForm.find(item => {
        return item.display_id === 'add_group';
      })))
      fields.push(addButtonItem);

      // 入力ルール付与
      fields = this.setting._addInputRules(
        fields,
        inputFields.action_field_settings,
        EmployeeRules,
        this.masterData.m_employee.body
      );

      this.fieldsData = this.setting.modifyInputAllow(fields, inputFields.action_field_settings);
      this.fieldCols = this.setting.getGridStatus(fields);

      // 管理マスタからユーザー登録画面用の定義を読込
      const userRegisterItem = Object.entries(
        appState.options['ユーザー登録']['登録画面']
      ).map(([key, text]) => ({ key, text }));
      const findItem = userRegisterItem.find(item=> {
        if(item.key === '企業・グループ追加登録用ベースグループ定義') {
          return item;
        }
      });

      this.registerBaseGroupItem = this.extractionGroupData.find((item: any) => {
        if(item.display_id === findItem!.text) {
          return item;
        }
      });

      this.registerEmployeeGroupItem = userRegisterItem.find(item=> {
        if(item.key === 'isFJAPAN_FLAG') {
          return item;
        }
      });
    } catch ($e) {
      console.log($e);
      this.setError($e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * getGroupTreeで取得した内容を配列に格納する
   */
  private extractionGroupDataCreate(data: any, arrayData: Array<{}>) {
    if (data !== null && typeof data === 'object' && data.constructor === Object) {
      arrayData.push(data);
    }
    for (const key in data) {
      if (typeof data[key] === 'object') {
        this.extractionGroupDataCreate(data[key], arrayData);
      }
    }
  }

  /**
   * ヘッダ情報フィールド定義作成
   */
  private getHeaderFields(formData: any) {
    const baseData = {
      cols: {},
      datas: {} as { [k: string]: any }
    };
    try {
      baseData.cols = this.setting.getGridStatus(formData);
      baseData.datas = formData;
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
    return baseData;
  }

  /**
   * ヘッダ情報フィールドデータ作成
   */
  private getHeaderData(setData: { [key: string]: any }, baseData: any) {
    try {
      Object.keys(setData).map((key: string) => {
        baseData.datas[key].props['value'] = setData[key];
      });
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
  }

  private async addGroupDialogEvent(event:any) {
    switch (event) {
      case "register": {
        try {
          this.$store.commit('hexabase/setIsLoading', true);
          this.addGroupDialog = false;
          // 発番番号の問い合わせ
          const autoNumber = await this.setting.getAutoNumber(
            this.applicationId,
            hexabaseState.datastoreIds['企業マスタ'],
            'id',
            {
              'zero_padding': 'true',
              'digit': '9'
            }
          );
          // 顧客番号Prefix(C-XXX)
          const id = autoNumber.result.value;
          // 管理マスタの定義値から0埋め用に文字列を作成
          const digit = Array(Number(appState.options['ユーザー登録']['企業・グループ追加ダイヤログ']['prefix用桁数'] + 1)).join('0');
          const num = Number(id);
          const cutomerPrefix = appState.options['ユーザー登録']['企業・グループ追加ダイヤログ']['顧客用prefix'] + ( digit + num ).slice( -digit.length ) + '-';
          // 案件番号Prefix(M-XXX)
          const matterPrefix = appState.options['ユーザー登録']['企業・グループ追加ダイヤログ']['案件用prefix'] + ( digit + num ).slice( -digit.length ) + '-';
          // 見積番号Prefix(E-XXX)
          const estimatePrefix = appState.options['ユーザー登録']['企業・グループ追加ダイヤログ']['見積用prefix'] + ( digit + num ).slice( -digit.length ) + '-';
          // 企業マスタの登録に必要な情報を設定
          this.adddGroupRegistData.item['company_name'] = this.dialogData!.datas[0].props.value;
          this.adddGroupRegistData.item['matter_number_prefix'] = matterPrefix;
          this.adddGroupRegistData.item['estimate_number_prefix'] = estimatePrefix;
          this.adddGroupRegistData.item['customer_number_prefix'] = cutomerPrefix;
          this.adddGroupRegistData.item['company_group_code'] = this.dialogData!.datas[1].props.value;
          this.adddGroupRegistData.item['remarks'] = this.dialogData!.datas[2].props.value;

          const adddGroupRegistResult: any = await this.setting.registerLinkedItems(
            this.applicationId,
            hexabaseState.datastoreIds['企業マスタ'],
            this.adddGroupRegistData
          );

          // 企業マスタの戻り値から会社グループ作成後に戻り値を利用して、社員グループを作成
          if (adddGroupRegistResult.error === true) {
            this.setError(adddGroupRegistResult.error);
          } else {
            // 企業・グループのグループ追加用ペイロード
            const companyParam = {
              "name" : this.dialogData!.datas[0].props.value,
              "display_id": this.dialogData!.datas[1].props.value
            }

            const companyGroupResult: any = await this.setting.createGroup(this.registerBaseGroupItem.id, companyParam);
          }
          this.button.map(v => {
            v.value = 'OK';
            v.route = ``;
          })
          this.setDialogMessage('企業・グループ追加を行いました。')
          this.reset();
        } catch ($e) {
          this.setDialogMessage($e);
          this.reset();
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
          this.setDialogStatus(true);
        }
        break;
      }
      case "cancel": {
        this.checkAddGroupFlag = false;
        this.addGroupDialog = false;
        break;
      }
      default:
        break;
    }
  }

  private catchDialogInput(input: { [k: string]: string }) {
    const groupName = '企業・グループ名';
    let groupNameCheckFlag = false;
    const groupCode = 'グループコード';
    let groupCodeCheckFlag = false;
    const inputItem = this.dialogData.datas.find((item:any) => {
      if (item.display_id === input.name) {
        return item;
      }
    });

    if (inputItem !== undefined) {
      inputItem.props.value = input.value;
    }

    // 重複チェックの為に企業・グループ名を検索
    const findCompanyName = this.masterData['m_company'].body.find((item:any) => {
      return this.dialogData.datas.find((dialogData:any) => {
        if(dialogData.display_id === 'company_name') {
          if (item.company_name === dialogData.props.value) {
            return item;
          }
        }
      })
    });

    if (findCompanyName !== undefined) {
      groupNameCheckFlag = true;
    }

    // 重複チェックの為に企業・グループコードを検索
    const findCompanyCode = this.masterData['m_company'].body.find((item:any) => {
      return this.dialogData.datas.find((dialogData:any) => {
        if(dialogData.display_id === 'company_group_code') {
          if (item.company_group_code === dialogData.props.value) {
            return item;
          }
        }
      })
    });

    if (findCompanyCode !== undefined) {
      groupCodeCheckFlag = true;
    }

    // 重複登録を防ぐ為に既存の企業マスタに存在するかの確認、登録するボタンの下にメッセージ表示
    if (groupNameCheckFlag === true || groupCodeCheckFlag === true) {
      this.checkAddGroupFlag = true;
      let message = '';
      message = groupNameCheckFlag === true ? groupName : '';
      if (groupCodeCheckFlag === true) {
        message = message === '' ? groupCode : message + '、' + groupCode;
      }
      this.addGroupDialogInformation.checkMessage = '入力した' + message + 'はすでに登録されています。'
    } else {
      this.checkAddGroupFlag = false;
      this.addGroupDialogInformation.checkMessage = '';
    }
  }

  private pushHandle(data: { [k: string]: string }): void {
    if(data.functionName !== undefined) {
      switch (data.functionName) {
        case "getAddress": {
          this.setting.setZipCloudAddress(
            data.eventData[0],
            ['prefectures', 'municipalities', 'machimura_street_address'],
            this.fieldsData
          );
          break;
        }
        case "addGroupButton": {
          this.addGroupDialogInformation.checkMessage = '';
          this.dialogData = this.getHeaderFields(
            JSON.parse(JSON.stringify(addGroupDialogForm))
          );
          this.addGroupDialog = true;
          break;
        }
        default:
          break;
      }
    }
  }

  /**
   * 自動生成要素からの入力を取得(ユーザーマスタ登録情報パネル側)
   * @param input {[k:string]: string}
   * @returns void
   */
  private catchInput(input: { [k: string]: string }): void {
    this.registDataPayload.item[input.name] = input.value;

    const index = this.fieldsData.findIndex(v => v.display_id === input.name);
    switch (this.fieldsData[index].component) {
      case 'MasterSelectControl':
      case 'MasterSelectSetControl':
      case 'MasterSelectMultiControl':
      case 'MasterSelectMultiSetControl': {
        this.$set(this.fieldsData[index].props!, 'value', { 'i_id': input.value });
        break;
      }
      default: {
        this.$set(this.fieldsData[index].props!, 'value', input.value);
        break;
      }
    }
  }

  /**
   * アイテム情報の更新・キャンセルを実行します
   * @param type - 押下されたボタンの種類
   * @returns void
   */
  private async execAction(type: string): Promise<void> {
    switch (type) {
      case 'register': {
        try {
          this.$store.commit('hexabase/setIsLoading', true);
          // 登録するのアクションIDを指定
          this.registDataPayload['action_id'] = 'register';
          const result = await this.setting.registerLinkedItems(
            this.applicationId,
            this.employeeMasterDsId,
            this.registDataPayload
          );
          this.setting.apiErrorHandle('CREATEITEM', result);
          
          // APIレスポンスのitem_idを社員マスタ詳細画面への遷移先に設定
          this.button.map(v => {
            v.value = '詳細画面へ',
            v.route = String(v.route).replace(':id', result.item_id);
          });
          this.setDialogMessage(EmployeeDetailDefine.regist.message.registSuccess);
          this.reset();
        } catch ($e) {
          this.setDialogMessage($e);
          this.reset();
        } finally {
          this.setDialogStatus(true);
          this.$store.commit('hexabase/setIsLoading', false);
        }
        break;
      }
      case 'cancel': {
        this.backPreviousPage();
        break;
      }
      default: {
        break;
      }
    }
  }

  private setDialogStatus(flg: boolean) {
    this.dialogStatus = flg;
  }
  private setDialogMessage(str: string) {
    this.bodyText = str;
  }

  private reset() {
    this.registDataPayload = {
      'item': {},
      'return_item_result': true,
      'return_display_id': true
    };
  }

  // 企業・グループ追加後のダイヤログ内ボタン押下処理
  private transitionDialogButtonPush() {
    try {
      if (this.button[0].value === 'OK') {
        this.$store.commit('hexabase/setIsLoading', true);
        this.$router.go(0);
      }
    } catch ($e) {
      this.setError($e);
    } finally {
      this.setDialogStatus(false);
    }
  }

  private setError(errorMessage: string): void {
    if (typeof errorMessage === 'object') errorMessage = this.setting.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  /**
   * 戻る処理
   */
  private backPreviousPage() {
    if (this.prevRoute) {
      const beforeRoute = { name: this.prevRoute.name, params: this.prevRoute.params, query: {} };
      const paths = this.prevRoute.fullPath.split('/');
      if (['list', 'searchlist'].includes(paths[paths.length - 1].toLowerCase())) {
        beforeRoute.query = { searchConditions: 'true' };
      }

      if (this.prevRoute.name !== null) {
        this.$router.push(beforeRoute);
      } else {
        this.$router.replace({ name: 'SettingEmployeeList', params: {} });
      }
    } else {
      this.$router.replace({ name: 'SettingEmployeeList', params: {} });
    }
  }

}
